module.exports = __webpack_public_path__ + "img/641.cf83c519.jpg";